import Axios from 'axios';

// For common config
Axios.defaults.headers.post['Content-Type'] = 'application/json';

const ceV2Axios = Axios.create();
const k1Axios = Axios.create();
const k1V2Axios = Axios.create();
const mktAxios = Axios.create();

export const initAxios = () => {
  ceV2Axios.defaults.baseURL = process.env.REACT_APP_API_URL_V2 ?? process.env.PUBLIC_URL;
  k1Axios.defaults.baseURL = process.env.REACT_APP_K1_API_URL ?? process.env.PUBLIC_URL;
  k1V2Axios.defaults.baseURL = process.env.REACT_APP_K1_API_V2_URL ?? process.env.PUBLIC_URL;
  mktAxios.defaults.baseURL = process.env.REACT_APP_MKT_API_URL ?? process.env.PUBLIC_URL;
};

export const setAuthorizationHeader = (token: string) => {
  Axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  ceV2Axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  k1Axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  k1V2Axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  mktAxios.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const rmAuthorizationHeader = () => {
  delete Axios.defaults.headers.common.Authorization;
  delete ceV2Axios.defaults.headers.common.Authorization;
  delete k1Axios.defaults.headers.common.Authorization;
  delete k1V2Axios.defaults.headers.common.Authorization;
  delete mktAxios.defaults.headers.common.Authorization;
};

export const setAccountUuidHeader = (accountUuid: string) => {
  ceV2Axios.defaults.headers.common['X-Account-Id'] = accountUuid;
};

export {
  Axios,
  ceV2Axios,
  k1Axios,
  k1V2Axios,
  mktAxios,
};
